export enum ProjectionType {
  Min = 'MIN',
  Listing = 'LISTING',
  Detailed = 'DETAILED',
  Cat = 'CAT',
  Catalog = 'CATALOG',
  Price_Catalog = 'PRICE_CATALOG',
  ProductMin = 'PRODUCT.MIN',
  PriceMin = 'PRICE.MIN',
  InventoryMin = 'INVENTORY.MIN',
  ItemAll = 'ITEM.ALL',
  ProductListing = 'PRODUCT.LISTING',
  ProductAll = 'PRODUCT.ALL',
  BrandAll = 'BRAND.ALL',
  CategoryMin = 'CATEGORY.MIN',
  TagAll = 'TAG.ALL',
}

export enum ProductType {
  Bundle = 'BUNDLE',
  Standard = 'STANDARD',
  Variant = 'VARIANT',
}

export enum TagType {
  Promotion = 'PROMOTION',
  Subscription = 'SUBSCRIPTION',
  Bundle = 'BUNDLE',
  Product = 'PRODUCT',
}
